import React from 'react'
import './SocialLinks.sass'
import Icon from '../../../ui/Icon/Icon'
import { Link } from 'react-router-dom'

function SocialLinks() {
  return (
    <div className="SocialLinks">
      <span className="Title">Мы в соц. сетях:</span>
      <a href="https://vk.com/hostelzapolyarje" target="blank">
        <Icon name="vk" weight="brand" />
      </a>
    </div>
  )
}

export default SocialLinks
